import React from 'react';
import { Link } from 'react-router-dom';

import PhotoOfAlan from 'core/images/AlanHoney.jpg';

class About extends React.Component {
    render() {
        return (
            <div>
                <h3 className="mb1">
                    About <em>Alan Honey Photography</em>
                </h3>

                <img
                    src={PhotoOfAlan}
                    css={{ height: 150 }}
                    className="left mr2"
                    alt="Alan Honey"
                />
                <p css={{ margin: 0 }}>
                    Alan opened <em>Alan Honey Photography</em> for business in Manhattan, Kansas,
                    in August of 2003, after a successful run as manager of one of the most
                    respected studios in the West. In Salt Lake City, his clients included Utah Jazz
                    players, Olympic athletes, and even Sheryl Crow. He specialized in portraits and
                    weddings but was also the principal photographer for a regional life-style
                    magazine. He has photographed weddings throughout the U.S. in places like
                    Boston, Washington D.C., San Diego, Las Vegas, and Dallas.
                </p>
                <div className="right">
                    <Link to="/about">more &rarr;</Link>
                </div>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/Home/components/About/index.js